// extracted by mini-css-extract-plugin
export default {"genericCard":"xn-z","inline":"yn-z","mastercard":"zn-z","discover":"An-z","visa":"Bn-z","amex":"Cn-z","active":"Dn-z"};